<template>
    <draggable
            :group="{ name: 'module', put: false, pull: 'clone' }"
            :sort="false"
            :value="childModules"
            class="card-drag"
    >
        <div v-for="item in childModules" :key="item.code" class="card-item-box">
            <!--规章制度、业务流程和常用下载-->
            <div class="card-item" v-if="item.code == 'TINFO_RULES'">
                <div class="titleClass">
                    <div class="flex-box al-c mb10" style="color: #024A84;">
                        <span class="ml10 font-14">{{item.title}}</span>
                    </div>
                    <div>更多<i class="el-icon-arrow-right"></i></div>
                </div>
                <template v-for="(e, i) in rulesList">
                    <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item" :key="i" v-if="i<5">
                        <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                        <span class="grey">{{e.createTime}}</span>
                    </p>
                </template>
                <div v-if="rulesList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
                <div class="selected" v-if="ifSelected(item)">已选</div>
            </div>
            <div class="card-item" v-if="item.code == 'TINFO_BUSINESS'">
                <div class="titleClass">
                    <div class="flex-box al-c mb10" style="color: #024A84;">
                        <span class="ml10 font-14">{{item.title}}</span>
                    </div>
                    <div>更多<i class="el-icon-arrow-right"></i></div>
                </div>
                <template v-for="(e, i) in businessList">
                    <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item" :key="i" v-if="i<5">
                        <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                        <span class="grey">{{e.createTime}}</span>
                    </p>
                </template>
                <div v-if="businessList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
                <div class="selected" v-if="ifSelected(item)">已选</div>
            </div>
            <div class="card-item" v-if="item.code == 'TINFO_DOWNLOAD'">
                <div class="titleClass">
                    <div class="flex-box al-c mb10" style="color: #024A84;">
                        <span class="ml10 font-14">{{item.title}}</span>
                    </div>
                    <div>更多<i class="el-icon-arrow-right"></i></div>
                </div>
                <template v-for="(e, i) in downloadList">
                    <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item" :key="i" v-if="i<5">
                        <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
                        <span class="grey">{{e.createTime}}</span>
                    </p>
                </template>
                <div v-if="downloadList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
                <div class="selected" v-if="ifSelected(item)">已选</div>
            </div>
        </div>
    </draggable>
</template>

<script>
    import draggable from "vuedraggable";
    import {getCardList} from '@/api/managementCenter/specialManage'
    export default {
        name: "linkMagaC",
        components: { draggable},
        props: ['childModules','homeModules'],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                rulesList: [],
                businessList: [],
                downloadList: [],
            };
        },
        created() {
        },
        computed: {},
        mounted(){
            this.getCardData('3');
            this.getCardData('4');
            this.getCardData('5');
        },
        methods: {
            handleWidth(col){
                switch (col) {
                    case 1:
                        return '100%'
                    case 2:
                        return '50%'
                    case 3:
                        return '33.3%'
                    case 4:
                        return '25%'
                    case 5:
                        return '20%'
                    case 6:
                        return '16.6%'
                    default:
                        return '50%'
                }
            },
            getCardData(type){
                let params = {
                    type: type || ''
                }
                getCardList(params).then(res =>{
                    if(type == '3'){
                        this.rulesList = res.data.data.records
                    }
                    if(type == '4'){
                        this.businessList = res.data.data.records
                    }
                    if(type == '5'){
                        this.downloadList = res.data.data.records
                    }
                })
            },
            addClick(data){
                this.$emit('addClick', data)
            },
            ifSelected(val){
                let cardModule = this.homeModules.find(item => item.cardType === 'LINKMAGA')
                if(cardModule){
                    if(cardModule.cardModules){
                        return cardModule.cardModules.some(item => item.code === val.code)
                    }
                    return false
                }
                return false
            }
        },
        watch: {},
        filters: {},
    };
</script>

<style lang="less" >
    .card-drag {
        height: 480px;
        overflow: scroll;
        .card-item-box {
            display: flex;
            justify-content: center;
            margin-bottom: 12px;
            .card-item {
                width: 380px;
                height: 220px;
                // text-align: center;
                // line-height: 160px;
                background-color: #eef4f9;
                border-radius: 4px;
                position: relative;
                padding: 10px;
                overflow: hidden;
                cursor: move;
                .msg-item {
                    line-height: 14px;
                    cursor: inherit;
                }
            }
        }
    }
    .titleClass{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px #e9e9e9 solid;
        padding: 5px 0;
    }
</style>